import { useMemo } from "react";
import { useSettings } from "../settings";
import { useAppStoreSelector } from "../../contexts/appStore/selectors";
import { SecondaryScreen, SecondaryScreenLayout } from "../../interfaces/secondaryScreens";
import { ScreenConstants } from "../../constants/screens";

export const useScreen = (): {
  screen?: SecondaryScreen,
  layout: SecondaryScreenLayout,
} => {
  const [settings] = useSettings();
  const screen = useAppStoreSelector(state => state.screen);

  const layout = useMemo(() => {
    const layoutId = screen?.layoutId;

    const layout = settings?.carousel?.layouts?.find((p) => {
      return p.id === layoutId;
    });

    return layout ?? ScreenConstants.DefaultLayout;
  }, [settings, screen]);
  
  return { layout, screen };
}
